import React from 'react'
import getOrderCatalogLabel from '../../utils/getOrderCatalogLabel'
import { getOrderOutletReason, getOrderOutletTheme } from '../../../../constants/outletThemes'
import OutletBadge from '../../../../ui/OutletBadge/OutletBadge'

export function OrderProductCatalogBadge({ isOutlet, outletReason, isGift }) {
  if (isGift) {
    return <span className="GiftBadge">Подарунок</span>
  }

  if (!isOutlet) {
    return <span className="PremiumBadge">Premium</span>
  }

  return (
    <OutletBadge outletReason={outletReason}>
      Outlet
    </OutletBadge>
  )
}

export function OrderCatalogBadges({ products }) {
  const catalogLabel = getOrderCatalogLabel(products)
  const outletReason = getOrderOutletReason(products)
  const outletTheme = getOrderOutletTheme(products)

  if (catalogLabel === 'Premium') {
    return <span className="PremiumBadge">Premium</span>
  }

  if (catalogLabel === 'Outlet') {
    return (
      <span className="OrderCatalogBadges">
        <OutletBadge theme={outletTheme} outletReason={outletReason}>
          Outlet
        </OutletBadge>
      </span>
    )
  }

  return (
    <span className="OrderCatalogBadges">
      <span className="PremiumBadge">Premium</span>
      <span className="OrderCatalogBadges-separator">+</span>
      <OutletBadge theme={outletTheme} outletReason={outletReason}>
        Outlet
      </OutletBadge>
    </span>
  )
}
